/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import {connect} from 'react-redux'
import {isPC, renderMoney} from '../../utils'
import MainItemTitle from './MainItemTitle'
import LiveroomCell from './LiveroomCell'
import config from '../../config'

class MainDatacenter extends React.Component {

    renderPCCellBody() {
        return(
            <a href="/pc">
                <div className="mainpage-datacenter-cell">
                    查看仪表盘
                </div>
            </a>
        )
    }

    handleMbCellClick() {
        let text = () => {
            return (
                <div style={{textAlign: 'left'}}>
                    电脑浏览器打开讲师管理后台（{config.ADMIN_BASE_URL}）可查看直播间数据详情
                </div>
            )
        };
        this.context.page.showAlert(text(), '','温馨提示');
    }

    renderMBCellBody() {
        return(
            <div className="mainpage-datacenter-cell" onClick={this.handleMbCellClick.bind(this)}>
                查看详情
            </div>
        )
    }

    render() {
        const {liveroomInfo} = this.props.liveroomSetting;
        return (
            <div className="mainpage-datacenter">
                <MainItemTitle content={'最新数据'}/>

                <div className="datacenter-container">
                    <div className="datacenter-container-item">
                        <p className="datacenter-num">{liveroomInfo.stats_info.yesterday_fans_count}</p>
                        <p className="datacenter-item">昨日新增粉丝</p>
                    </div>
                    <div className="datacenter-container-item">
                        <p className="datacenter-num">{liveroomInfo.stats_info.fans_count}</p>
                        <p className="datacenter-item">累计粉丝</p>
                    </div>
                    <div className="datacenter-container-item">
                        <p className="datacenter-num datacenter-num-red">{renderMoney(liveroomInfo.stats_info.yesterday_earn)}</p>
                        <p className="datacenter-item">昨日收益（元）</p>
                    </div>
                </div>

                {isPC() &&
                <LiveroomCell body={this.renderPCCellBody()}/>
                }
                {!isPC() &&
                <LiveroomCell body={this.renderMBCellBody()}/>
                }
            </div>
        )
    }
}

MainDatacenter.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    liveroomSetting: state.liveroomSetting
}))(MainDatacenter)



// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainDatacenter.js